import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AreaLoader } from '../UI';
import { useAppSelector, useCheckIsUserAuthorized } from '../../hooks';

export const ProtectedRoute = () => {
  const location = useLocation();
  const { cognitoUser } = useAppSelector((state) => state.cognito);
  const { isUserAuthorizedChecking } = useCheckIsUserAuthorized();

  if (isUserAuthorizedChecking) {
    return <AreaLoader />;
  }

  if (cognitoUser.isAuthorized) {
    return <Outlet />;
  }

  return <Navigate to="/auth" state={{ from: location }} replace />;
};
